import React from "react";
import Td from "../../../components/td";
import ModalSearch from "../../../components/modalSearch";
import { formatInteger, getData, Subscribe, UnSubscribe, formatNumber } from "../../../components/utilities";
import { Api as Keep } from "../../../services/keep";

class Stocks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "__Stocks",
      title: "Stock de material",
      name: "SUPORT-KEEP-STOCK",
      show: false,
      rows: 30,
      vale_id: props._id,
      data: {
        list: [],
        search: "",
        page: 1,
        rows: 30,
        int: 0,
        end: 0,
        count: 0,
        all: 0,
        vale_id: "-1",
      },
      select: { _id: "-1", caption: "" },
      change: false,
    };
  }

  eventSetData = (e) => {
    setTimeout(() => {
      this.handleUpdate(e);
    }, 500);
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleUpdate = (e) => {
    this.handleData(false);
  };

  handleSearch = () => {
    this.handleData(false);
  };

  handleData = (scroll) => {
    const vale_id = this.props._id;
    const search = this.state.data.search;
    const rows = this.state.rows;
    if (scroll) {
      const page = this.state.data.page + 1;
      Keep.summary(vale_id, "ALL", search, page, rows, this.state.data.list).then((result) => {
        const data = result.data;
        this.setState({
          vale_id: vale_id,
          data: data,
        });
      });
    } else {
      Keep.summary(vale_id, "ALL", search, 1, rows, []).then((result) => {
        const data = result.data;
        this.setState({
          vale_id: vale_id,
          data: data,
        });
      });
    }
  };

  handleScroll = (e) => {
    const h = e.target.scrollTop + e.target.clientHeight + 1;
    if (e.target.id === `${this.state._id}_scroll` && h >= e.target.scrollHeight) {
      this.handleData(true);
    }
  };

  componentDidMount() {
    Subscribe(`SUPORT-KEEP/${this.state.vale_id}`, (event) => this.eventSetData(event));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.show) {
      if (prevState.vale_id !== this.state.vale_id) {
        UnSubscribe(`SUPORT-KEEP/${this.state.vale_id}`, (event) => this.eventSetData(event));
        Subscribe(`SUPORT-KEEP/${this.state.vale_id}`, (event) => this.eventSetData(event));
      }
      if (prevProps.show !== this.props.show) {
        this.handleData(false);
      }
    }
  }

  componentWillUnmount() {
    UnSubscribe(`SUPORT-KEEP/${this.state.vale_id}`, (event) => this.eventSetData(event));
  }

  render() {
    return (
      <React.Fragment>
        <Td className="suport-tool" cols="34% auto">
          <ModalSearch name="search" value={this.state.data.search} onChange={this.handleChange} onSearch={this.handleSearch} />
          <div className={this.state.data.all > 0 ? "scroll-count" : "d-none"}>
            <p>
              <b className="scroll-count-end">{formatInteger(this.state.data.end)}</b>
              de
              <b className="scroll-count-all">{formatInteger(this.state.data.all)}</b>
            </p>
          </div>
        </Td>
        <div className="suport mb-0">
          <div className="suport-group mb-0">
            <Td className="suport-head" cols="100px auto 35px 90px 90px 90px 90px 94px">
              <div className="suport-td">Referencia</div>
              <div className="suport-td">Descripción</div>
              <div className="suport-td">Und</div>
              <div className="suport-td">Entregas</div>
              <div className="suport-td">Existencias</div>
              <div className="suport-td">Consumos</div>
              <div className="suport-td">Reintegros</div>
              <div className="suport-td">Tranferencias</div>
            </Td>
            <div className="suport-scroll small" id={`${this.state._id}_scroll`} onScroll={this.handleScroll}>
              {this.state.data.list.map((item, i) => {
                return (
                  <Td key={i} className="suport-item" cols="25px 75px auto 35px 90px 90px 90px 90px 90px">
                    <div className="suport-td t-c">{i + 1}</div>
                    <div className="suport-td t-c">{item.code}</div>
                    <div className="suport-td">{item.caption}</div>
                    <div className="suport-td t-c">{getData(item, "unity", "")}</div>
                    <div className="suport-td t-r">{formatNumber(item.deliveries)}</div>
                    <div className="suport-td t-r">{formatNumber(item.stock)}</div>
                    <div className="suport-td t-r">{formatNumber(item.consumptions)}</div>
                    <div className="suport-td t-r">{formatNumber(item.refunds)}</div>
                    <div className="suport-td t-r">{formatNumber(item.transfers)}</div>
                  </Td>
                );
              })}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Stocks;
